import { z } from 'zod';
import { cuid } from './primitives.js';

/** Registros que tem historico com "Desfazer" (Sessao 28): o recurso da trilha de auditoria. */
export const RECURSOS_DESFAZIVEIS = ['fichas_tecnicas', 'valores_recuperacao', 'cifs'] as const;
export const recursoDesfazivel = z.enum(RECURSOS_DESFAZIVEIS);
export type RecursoDesfazivel = z.infer<typeof recursoDesfazivel>;

/** GET /desfazer/registro?recurso=&chave=&limite=: `chave` = id do registro (ficha, CIF) ou do item (valor de recuperacao). */
export const historicoRegistroQuerySchema = z.object({ recurso: recursoDesfazivel, chave: cuid, limite: z.coerce.number().int().min(1).max(50).default(20) });
export type HistoricoRegistroQuery = z.infer<typeof historicoRegistroQuerySchema>;

export interface HistoricoRegistroItem {
  /** Id do evento da trilha (o que o "Desfazer" recebe). */
  id: string;
  acao: string;
  /** Texto em portugues do que mudou ("Componentes da ficha alterados"). */
  rotulo: string;
  usuarioNome: string | null;
  createdAt: string;
  /** E a ultima alteracao do registro, de um tipo que sabe voltar, e quem pede pode editar. */
  desfazivel: boolean;
}
export interface HistoricoRegistroResponse {
  itens: HistoricoRegistroItem[];
}

/** POST /desfazer/:id */
export interface DesfazerResponse {
  desfeito: string;
  rotulo: string;
}
